<template>
  <div class="line" :style="style" :class="classes">
    <connection-line-statement :statement="text" @statementChange="statementChange($event)" :statementLine="statementLine" v-if="statementLine"></connection-line-statement>
  </div>
</template>

<script>
import ConnectionLineStatement from '@/components/ConnectionLineStatement'

export default {
  name: 'ConnectionLine',
  props: ['x', 'y', 'length', 'orientation', 'statement', 'statementLine'],
  components: {
    ConnectionLineStatement
  },
  data () {
    return {
      text: this.statement
    }
  },
  methods: {
    statementChange (input) {
      this.text = undefined
    }
  },
  computed: {
    style () {
      let x = this.x
      let y = this.y
      let length = this.length

      if (length < 0) {
        x = x + length
        length = Math.abs(length)
      }

      if (this.orientation === 'horizontal') {
        length = length + 3
      }

      return {
        left: x + 'px',
        top: y - 3 + 'px',
        width: length + 'px'
      }
    },

    classes () {
      return {
        '-vertical': this.orientation === 'vertical'
      }
    }
  }
}
</script>

<style lang="scss">

.line {
  position: absolute;
  background-color: $color-action;
  height: 3px;
  transform-origin: top left;
  transform: translateX(-3px);
  z-index: 1;

  &.-vertical {
    transform: translateY(3px) rotate(90deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ConnectionLine.vue